// Get Products
function getProducts() {
  const $main = document.querySelector("#main-collection-product-grid");
  if (!$main) return Error("Main collection product grid not found");

  const section_id = $main.dataset.sectionId;
  if (!section_id) return Error("Section ID not found");

  const $productGrid = document.querySelector("#collection-product-grid");
  if (!$productGrid) return Error("Collection product grid not found");

  const $productCount = document.querySelector("#collection-product-count");
  if (!$productGrid) return Error("Collection product count not found");

  const $pagination = document.querySelector("#collection-pagination");

  const params = new URLSearchParams(window.location.search);
  params.delete("page");
  params.set("section_id", section_id);

  fetch(`${window.location.pathname}?${params.toString()}`)
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const $newProductCount = doc.querySelector("#collection-product-count");
      if (!$newProductCount) return Error("New collection product count not found");
      const $newProductGrid = doc.querySelector("#collection-product-grid");
      if (!$newProductGrid) return Error("New collection product grid not found");
      $productCount.innerHTML = $newProductCount.innerHTML;
      $productGrid.innerHTML = $newProductGrid.innerHTML;

      const $newPagination = doc.querySelector("#collection-pagination");
      if ($pagination) {
        $pagination.innerHTML = $newPagination ? $newPagination.innerHTML : "";
        // Section-rendered links carry section_id, which would return the bare section on navigation
        $pagination.querySelectorAll("a[href]").forEach((link) => {
          const url = new URL(link.getAttribute("href"), window.location.origin);
          url.searchParams.delete("section_id");
          link.setAttribute("href", `${url.pathname}${url.search}${url.hash}`);
        });
      }
    });
}

// Sort
function initSort() {
  const $collectionSort = document.querySelector("#collection-sort");
  if (!$collectionSort) return;

  $collectionSort.addEventListener("change", (e) => {
    const sort = e.target.value;
    const params = new URLSearchParams(window.location.search);
    params.delete("page");
    params.set("sort_by", sort);
    history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    getProducts();
  });
}

function removeFilters() {
  document.addEventListener("DOMContentLoaded", () => {
    const removeFilterButtons = document.querySelectorAll("[data-remove-filters]");
    const allFilter = document.querySelector("[data-all");
    removeFilterButtons.forEach((button) =>
      button.addEventListener("click", () => {
        const tags = Array.from(document.querySelectorAll("[data-collection-filter]"));
        tags.forEach((tag) => {
          tag.checked = false;
        });
        let url = window.location.pathname;
        allFilter.checked = true;
        history.replaceState({}, "", `${window.location.pathname}`);
        getProducts();
      }),
    );
  });
}

function filterProduct() {
  document.addEventListener("DOMContentLoaded", () => {
    const tags = Array.from(document.querySelectorAll("[data-collection-filter]"));
    const allFilter = document.querySelector("[data-all]");
    const params_url = new URLSearchParams(window.location.search);
    const params_array = params_url.getAll("filter.p.product_type");
    params_array.length < 1 ? (allFilter.checked = true) : (allFilter.checked = false);

    let separated_url_tags = [];
    params_array.forEach((tag) => {
      if (tag.includes(",")) {
        let split_tags = tag.split(",");
        split_tags.forEach((split_tag) => separated_url_tags.push(split_tag));
      } else {
        separated_url_tags.push(tag);
      }
    });
    tags.forEach((tag) => {
      if (separated_url_tags.includes(tag.value)) {
        tag.checked = true;
      }
    });
    tags.forEach((element) => {
      element.addEventListener("click", () => {
        allFilter.checked = false;
        const params = new URLSearchParams(window.location.search);
        const filters = Array.from(document.querySelectorAll("[data-collection-filter]"));
        const $$checkedFilters = filters.filter((filter) => filter.checked === true).map((filter) => filter.value);

        // Clear product type params
        params.delete("page");
        params.delete("filter.p.product_type");

        $$checkedFilters.forEach((filter) => {
          params.append("filter.p.product_type", filter);
        });
        
        history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);

        getProducts();
      });
    });
  });
}


initSort();
filterProduct();
removeFilters();
